





































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class JS009 extends Vue {
    @Prop({ type: [Number, String] })
    year!: number;
    form = {
        accountBookId: this.$store.state.accountBook.id,
        year: this.year,
        num: 0,
        isSecretary: <null | number>null,
        isPartyMember: <null | number>null,
        partyOrganSystem: "",
        isBuildParty:<string | number> 1,
        partyName: "",
        partyCode: "",
        partySocialCode: "",
        partyBuilderName: "",
        email: "",
        officeTelephone: "",
        mobilePhone: "",
        partyAffiliateUnit: "",
        partyAnnualNewMember: "",
        partyFormTime: "",
        partyBuildWay: "",
        teamNum:"",
        teamBuild:<null | number>null,
        isOperatorTeam:<null | number>null,
        isOperatorTeamSecretary:<null | number>null,
    }
    formLn:any = {
        accountBookId: this.$store.state.accountBook.id,
        year: this.year,
    }
    mounted() {
        console.log(this.$store.state.accountBook.accountBookInfo)
        this.fetchData();
    }
    async save() {
        if(this.$store.state.accountBook.accountBookInfo.province !==  "辽宁省") {
           const keys = Object.keys(this.form);
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                if(this.$store.state.accountBook.accountBookInfo.province !==  "湖南省") {
                    if(key === "num" || key === "partyOrganSystem" || key === "isPartyMember" || key === "isSecretary") {
                        // @ts-ignore
                        if ((this.form[key] === null || this.form[key] === "") && key !=="id"  && key !== "gmtCreate" && key !== "gmtModified") {
                            this.$notify({
                                title: "温馨提示",
                                message: "请将所有信息填写完整",
                                type: "warning"
                            });
                            return
                        }
                    }
                    if(this.$store.state.accountBook.accountBookInfo.province ===  "北京市") {
                        if(key === "teamNum" || key === "teamBuild" || key === "isOperatorTeam" || key === "isOperatorTeamSecretary") {
                        // @ts-ignore
                            if ((this.form[key] === null || this.form[key] === "") && key !=="id"  && key !== "gmtCreate" && key !== "gmtModified") {
                                this.$notify({
                                    title: "温馨提示",
                                    message: "请将所有信息填写完整",
                                    type: "warning"
                                });
                                return
                            }
                        }
                    }
                } else {
                if(this.form.isBuildParty === 1) {
                    // @ts-ignore
                    if ((this.form[key] === null || this.form[key] === "") && key !=="id" && key !== "gmtCreate" && key !== "gmtModified") {
                        this.$notify({
                            title: "温馨提示",
                            message: "请将所有信息填写完整",
                            type: "warning"
                        });
                        return
                    }
                }else {
                    if(key === "isBuildParty" || key === "isPartyMember" || key === "isSecretary"|| key === "num"|| key === "partyOrganSystem" || key === "partyBuildWay"|| key === "partyFormTime") {
                        if ((this.form[key] === null || this.form[key] === "")) {
                            this.$notify({
                                title: "温馨提示",
                                message: "请将所有信息填写完整",
                                type: "warning"
                            });
                            return
                        }
                    }
                }

            }
        }
        await Vue.axios.post(`gsnb/djxx/save`, this.form);
        this.fetchData()
        this.$emit("update", this.form);
        }
        else {
            const keys = Object.keys(this.formLn);
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                // @ts-ignore
                if ((this.formLn[key] === null || this.formLn[key] === "") && key !=="id" && key !== "gmtCreate" && key !== "gmtModified") {
                        this.$notify({
                            title: "温馨提示",
                            message: "请将所有信息填写完整",
                            type: "warning"
                        });
                        return
                }
            }
            await Vue.axios.post(`gsnb/djxx/ln/save`, this.formLn);
            this.fetchData()
            this.$emit("update", this.form);
        }
    }
    async fetchData() {
        let url ="gsnb/djxx/get"
        if(this.$store.state.accountBook.accountBookInfo.province ===  "辽宁省") {
            url = "gsnb/djxx/ln/get"
        }
        const res = await Vue.axios.get(url + `?accountBookId=${this.$store.state.accountBook.id}&year=${this.year}`);
        if (res.data.data) {
            if(this.$store.state.accountBook.accountBookInfo.province ===  "辽宁省") this.formLn = res.data.data
            else this.form = res.data.data
        }
    }

}
